Bingo.AdManager = {};

Bingo.AdManager.prepareAd = (htmlId, adManagerId) => {
    const zone = document.getElementById(htmlId);
    if (zone !== null && zone.children.length === 0) {
        zone.innerHTML = `<div id='${adManagerId}' style='width: 300px; height: 366px;'></div>`;
        googletag.cmd.push(() => { googletag.display(adManagerId); });
    }
};

const AdConfig = [
    {
        htmlId: 'js-ad-manager-zone-lp-1',
        adManagerId: 'lp1',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-2',
        adManagerId: 'lp2',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-3',
        adManagerId: 'lp3',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-4',
        adManagerId: 'lp4',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-5',
        adManagerId: 'lp5',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-6',
        adManagerId: 'lp6',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-7',
        adManagerId: 'lp7',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-8',
        adManagerId: 'lp8',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-9',
        adManagerId: 'lp9',
    },
    {
        htmlId: 'js-ad-manager-zone-lp-10',
        adManagerId: 'lp10',
    },
    {
        htmlId: 'js-ad-manager-zone-search-1',
        adManagerId: 'search',
    },
    {
        htmlId: 'js-ad-manager-zone-search-2',
        adManagerId: 'search2',
    },
    {
        htmlId: 'js-ad-manager-zone-search-3',
        adManagerId: 'search3',
    },
    {
        htmlId: 'js-ad-manager-zone-search-4',
        adManagerId: 'search4',
    },
    {
        htmlId: 'js-ad-manager-zone-search-5',
        adManagerId: 'search5',
    },
    {
        htmlId: 'js-ad-manager-zone-search-6',
        adManagerId: 'search6',
    },
    {
        htmlId: 'js-ad-manager-zone-search-7',
        adManagerId: 'search7',
    },
    {
        htmlId: 'js-ad-manager-zone-search-8',
        adManagerId: 'search8',
    },
    {
        htmlId: 'js-ad-manager-zone-search-9',
        adManagerId: 'search9',
    },
    {
        htmlId: 'js-ad-manager-zone-search-10',
        adManagerId: 'search10',
    },
    {
        htmlId: 'js-ad-manager-zone-search-sidebar-1',
        adManagerId: 'search-sidebar-1',
    },
    {
        htmlId: 'js-ad-manager-zone-search-sidebar-2',
        adManagerId: 'search-sidebar-2',
    },
    {
        htmlId: 'js-ad-manager-zone-od-1',
        adManagerId: 'od1',
    },
    {
        htmlId: 'js-ad-manager-zone-od-2',
        adManagerId: 'od2',
    },
    {
        htmlId: 'js-ad-manager-zone-od-3',
        adManagerId: 'od3',
    },
    {
        htmlId: 'js-ad-manager-zone-od-4',
        adManagerId: 'od4',
    },
    {
        htmlId: 'js-ad-manager-zone-od-5',
        adManagerId: 'od5',
    },
    {
        htmlId: 'js-ad-manager-zone-od-6',
        adManagerId: 'od6',
    },
    {
        htmlId: 'js-ad-manager-zone-od-7',
        adManagerId: 'od7',
    },
    {
        htmlId: 'js-ad-manager-zone-od-8',
        adManagerId: 'od8',
    },
    {
        htmlId: 'js-ad-manager-zone-od-9',
        adManagerId: 'od9',
    },
    {
        htmlId: 'js-ad-manager-zone-od-10',
        adManagerId: 'od10',
    },
    {
        htmlId: 'js-ad-manager-zone-od-rc',
        adManagerId: 'od-rc',
    },
];

Bingo.AdManager.init = (htmlId) => {
    const found = AdConfig.find(element => element.htmlId === htmlId);
    if (found !== undefined) {
        Bingo.AdManager.prepareAd(found.htmlId, found.adManagerId);
    }
};
